export const SECTION_PICKER_DATA = [
  {
    id: 1,
    name: "address",
    content: "",
  },
  {
    id: 2,
    name: "account",
    content: "",
  },
  {
    id: 3,
    name: "company",
    content: "",
  },
];

export enum TemplateGroups {
  CASE = "Case",
  SUBCASE = "SubCase",
  DEBTOR = "Debtor",
  CREDITOR = "Creditor",
}

export enum DocumentType {
  ALL = "All",
  PDF = "PDF",
  SMS = "SMS",
  EHF = "EHF",
  EMAIL = "Email",
}

export const EMPTY_SECTION = "Empty";
